<form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4">
  <div class="form-group row">
    <div class="col-md-6">
      <div class="form-group row">
        <div class="col-md-6">
          <yt-fw-date-picker-popup formControlName="DatumOd" name="txtDatumOd"
            [Label]="'PROMETROBEZAKOMITENTAPOARTIKLIMA.DATUMOD.SINGULAR'">
          </yt-fw-date-picker-popup>
          <div class="form-error" *ngIf="submitted && fc.DatumOd.invalid">
            <span *ngFor="let validation of errorMessages.DatumOd">
              <span class="error-message" *ngIf="fc.DatumOd.hasError(validation.type)">
                <span [ngClass]="{'slideInRight': fc.DatumOd.hasError(validation.type), 'animated': true}"
                  translate="{{validation.message}}"></span>
              </span>
            </span>
          </div>
        </div>
        <div class="col-md-6">
          <yt-fw-date-picker-popup formControlName="DatumDo" name="txtDatumDo"
            [Label]="'PROMETROBEZAKOMITENTAPOARTIKLIMA.DATUMDO.SINGULAR'">
          </yt-fw-date-picker-popup>
          <div class="form-error" *ngIf="submitted && fc.DatumDo.invalid">
            <span *ngFor="let validation of errorMessages.DatumDo">
              <span class="error-message" *ngIf="fc.DatumDo.hasError(validation.type)">
                <span [ngClass]="{'slideInRight': fc.DatumDo.hasError(validation.type), 'animated': true}"
                  translate="{{validation.message}}"></span></span>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="form-group row">
        <button type="button" class="btn btn-primary" (click)="LoadData()" [disabled]="podaciSuUcitani">
          Učitaj podatke
        </button>
        <button type="button" class="btn btn-primary" (click)="MenjajUslove()" [disabled]="!podaciSuUcitani">
          Menjaj uslove
        </button>
        <!-- <button type="button" class="btn btn-primary" (click)="LoadPDF()">
          <span class="fa fa-fw fa-print"></span>
          Štampaj
        </button> -->

      </div>

    </div>
  </div>

  <div class="form-group row">
    <div class="col-md-12">
      <yt-dropdown-picklist
        [ModelName]="'komitent'"
        [GetName]="'get'"
        [ModelProperty]="'Naziv'"
        [OrderBy]="'Naziv'"
        [AllowAddNew]="false"
         formControlName="KomitentID"
        [Label]="'PROMETROBEZAKOMITENTAPOARTIKLIMA.KOMITENT.SINGULAR'"
        [ngClass]="{'is-invalid': submitted && fc.KomitentID.invalid}">
      </yt-dropdown-picklist>
      <!-- <div class="form-error" *ngIf="submitted && fc.KomitentID.invalid">
        <span *ngFor="let validation of errorMessages.KomitentID">
          <span class="error-message" *ngIf="fc.KomitentID.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
        </span>
      </div> -->
    </div>
  </div>

  <div class="form-group row">
    <!-- <div class="col-md-3"> -->
    <!-- <button type="button" class="btn btn-primary" (click)="LoadData()">
        Učitaj podatke
      </button>
    </div> -->
    <div class="col-md-6">
      <label for="rdbVrstaIzvestaja" class="control-label col-md-2"><span>Tip izveštaja: </span></label>
      <div class="form-check form-check-inline">
        <input class="form-check-input" type="radio" value="false" formControlName="VrstaIzvestajaSintetickiRpt">
        <span class="form-check-label" translate="PROMETROBEZAKOMITENTAPOARTIKLIMA.ANALITICKI"></span>
      </div>
      <div class="form-check form-check-inline ml-2">
        <input class="form-check-input" type="radio" value="true" formControlName="VrstaIzvestajaSintetickiRpt">
        <span class="form-check-label" translate="PROMETROBEZAKOMITENTAPOARTIKLIMA.SINTETICKI"></span>
      </div>

      <button type="button" class="btn btn-primary" (click)="LoadPDF()">
        <span class="fa fa-fw fa-print"></span>Štampaj
      </button>
    </div>
      <!-- <div class="col-md-3">
        <button type="button" class="btn btn-primary" (click)="LoadUkupno()">
          U K U P N O
        </button>
      </div> -->

    </div>
    <div class="row">
        <div class="col-12 text-right">
          <button type="button" class="btn btn-primary" (click)="LoadSumForm()" [disabled]="!podaciSuUcitani">
            U K U P N O
          </button>
        </div>
      </div>
  
</form>


<yt-fw-default-table *ngIf="modelData!=null && modelData.MainList!=null" [Config]="Config" [Items]="items"
  [TableColumns]="modelData.MainList.TableColumns" [Condensed]="CondensedTable" [ShowLoader]="MainItemsLoading"
  (RefreshDataClicked)="RefreshData()" (ItemSelected)="TableItemSelected($event)">
</yt-fw-default-table>